import { hot } from 'react-hot-loader';

import configureApp from 'config';
import App from './App';

configureApp();

export default hot(module)(App);
